// STY-635: board "warming" policy for the Post Builder.
//
// Dropping an image saves the placement (authoritative) and then asks the blog
// to build the image's board. The publish path builds any board that is
// missing, so the drop-time call is a cache warm: it must never block the
// editor, never touch the document, and never pile onto a struggling image
// server.

export const WARM_MAX_ATTEMPTS = 3
export const WARM_BACKOFF_MS = 500

// The image server is overloaded. Retrying deepens the very queue that is
// timing out (2026-09-11: every board request 503'd after 20-26 s while the
// image server was saturated) and gains nothing, because import will build the
// board once the server has headroom.
const NO_RETRY_STATUS = [503, 504]

export function shouldRetryWarm (err, attempt, maxAttempts = WARM_MAX_ATTEMPTS) {
  if (attempt + 1 >= maxAttempts) return false
  // STY-634: WordPress logged us out; the interceptor is already refreshing.
  if (err && err.wpSessionExpired) return false
  const status = err && err.response && err.response.status
  if (NO_RETRY_STATUS.indexOf(status) !== -1) return false
  return true
}

export function warmDelay (attempt, base = WARM_BACKOFF_MS) {
  return base * Math.pow(2, attempt)
}

// One warm in flight at a time. Drops arrive in bursts (an editor placing ten
// images in a minute) and each warm is a multi-second image-server job, so
// fanning them out in parallel is what turned a slow image server into a
// blocked one. A failed task never blocks the ones queued behind it.
export function createSerialQueue () {
  let tail = Promise.resolve()
  return function enqueue (task) {
    const run = tail.then(() => task())
    tail = run.catch(() => {})
    return run
  }
}
